if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
    evt.preventDefault();
    if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

    this.handleErrorMessage();
    this.submitButton.setAttribute('aria-disabled', true);
    this.submitButton.classList.add('loading');
    this.querySelector('.loading__spinner').classList.remove('hidden');

    const protectionID = document.getElementById('shipping-protection-toggle');
    if (protectionID) {
        jQuery.getJSON('/cart.js', (cart) => {
            let itemExists = cart.items.some(item => item.handle === "shipping-protection-1");

            if (!itemExists) {
                console.log("Adding shipping protection before main product.");
                let formData = {
                    'items': [{
                        'id': protectionID.value,
                        'quantity': 1,
                    }]
                };

                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: '/cart/add.js',
                    data: formData,
                    success: () => {
                        console.log("Shipping protection added. Proceeding with main product.");
                        this.addMainProduct();
                    },
                    error: () => {
                        console.error("Failed to add shipping protection.");
                        this.submitButton.classList.remove('loading');
                        this.querySelector('.loading__spinner').classList.add('hidden');
                        this.submitButton.removeAttribute('aria-disabled');
                    }
                });
            } else {
                console.log("Shipping protection already in cart. Proceeding with main product.");
                this.addMainProduct();
            }
        });
    } else {
        console.log("No shipping protection toggle found. Proceeding with main product.");
        this.addMainProduct();
    }
}

addMainProduct() {
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData(this.form);
    if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map(section => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
    }
    config.body = formData;

    $('.addons_list .addons_list_item').each(function(){
            var id =  $(this).find('input:checked').val();
            var qty = $(this).find('input[type="number"]').val();
            if( id != undefined){
              if( qty > 0 ) addp(id,qty);
            }
        });
        function addp(v,q) {
          $.ajax({
            type:"post",
            dataType: "json",
            async:false,
            url: '/cart/add.js',
            data:{quantity:q,id:v},
            success: function(data){
            }
          });
        };


    fetch(`${routes.cart_add_url}`, config)
        .then(response => response.json())
        .then(response => {
            if (response.status) {
                publish(PUB_SUB_EVENTS.cartError, {
                    source: 'product-form',
                    productVariantId: formData.get('id'),
                    errors: response.errors || response.description,
                    message: response.message,
                });
                this.handleErrorMessage(response.description);
                const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                if (soldOutMessage) {
                    this.submitButton.setAttribute('aria-disabled', true);
                    this.submitButtonText.classList.add('hidden');
                    soldOutMessage.classList.remove('hidden');
                }
                this.error = true;
                return;
            }

            if (!this.cart) {
                window.location = window.routes.cart_url;
                return;
            }

            if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
            });

            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
                document.body.addEventListener('modalClosed', () => {
                    setTimeout(() => { this.cart.renderContents(response); });
                }, { once: true });
                quickAddModal.hide(true);
            } else {
                this.cart.renderContents(response);
            }
        })
        .catch(e => console.error(e))
        .finally(() => {
            $('.upgrade-offer-modal__close').trigger('click');
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
            new Glide('.glide').mount();
        });
}


      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
